import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { WaybillOverviewData } from '../../models/waybill-overview.model';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import { WaybillOverviewLoad, WaybillOverviewSetInitialState } from './waybill-overview.actions';
import { WaybillOverviewService } from './waybill-overview.service';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface WaybillOverviewStateModel {
  overview: WaybillOverviewData;
  loaded: boolean;
}

const initialState: WaybillOverviewStateModel = {
  overview: null,
  loaded: false,
};

@State<WaybillOverviewStateModel>({
  name: 'waybillOverview',
  defaults: initialState,
})
@Injectable()
export class WaybillOverviewState {
  constructor(
    private waybillOverviewService: WaybillOverviewService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getLoaded(state: WaybillOverviewStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getOverview(state: WaybillOverviewStateModel): WaybillOverviewData {
    return state.overview;
  }

  @Action(WaybillOverviewLoad)
  loadOverview(
    ctx: StateContext<WaybillOverviewStateModel>,
    { payload }: WaybillOverviewLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.waybillOverviewService.getOverview(payload).pipe(
      map((overview: WaybillOverviewData) => {
        ctx.patchState({ overview, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(WaybillOverviewSetInitialState)
  setInitialState(ctx: StateContext<WaybillOverviewStateModel>): void {
    ctx.setState(initialState);
  }
}
